import { Navigate } from "react-router-dom";

/**
 * Legacy URL — /admin/email-queue used to render a tab-switcher with the same
 * Communications feed AND a Retry Queue tab. Both now live under
 * /admin/communications. This component is a permanent redirect so old
 * bookmarks land on the Failed / Retry tab.
 */
export default function AdminEmailQueue() {
  return <Navigate to="/admin/communications?tab=retry" replace />;
}
